import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { INavItem } from '../../models/nav-item.model';
import { NgClass } from '@angular/common';

@Component({
  selector: 'lh-navigation-item',
  template: `
    <div
      class="navigation-item"
      [ngClass]="{ 'navigation-item--active': isActive || isSelected }"
      (click)="clicked.emit()"
    >
      <div class="navigation-item__icon">
        <img [attr.src]="isActive || isSelected ? item!.activeIcon : item!.inactiveIcon" alt="activation status icon" />
      </div>
      <div class="navigation-item__label">{{ item!.label }}</div>
    </div>
  `,
  styleUrls: ['./navigation-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgClass],
})
export class NavigationItemComponent {
  @Input({ required: true }) item!: INavItem;
  @Input() isSelected: boolean = false;
  @Input() isActive: boolean = false;
  @Output() readonly clicked: EventEmitter<void> = new EventEmitter<void>();
}
